import { z } from 'zod';

// Email validation schema
const emailSchema = z
    .string()
    .min(1, 'Email is required')
    .email('Enter a valid email address');

export { emailSchema };
//# sourceMappingURL=email.js.map
